export default {
    // Header Section
    "discover_your": "Discover Your",
    "numerology": "Numerology",
    "numbers_reveal_destiny": "Numbers Reveal Your Destiny",
    "numerology_description": "Unlock the mystical power of numbers in your life with comprehensive numerological analysis covering your life path, destiny number, personality traits, and divine numerical influences that shape your journey.",

    // Service Information
    "enter_details_for_numerology": "Enter Your Details for Numerology",
    "complete_numerology_analysis": "Complete Numerology Analysis",
    "service_price": "Service Price",
    "comprehensive_numerology_analysis_note": "Deep dive into your numerical blueprint and discover your life's divine mathematical patterns",

    // Form Fields
    "full_name": "Full Name",
    "enter_full_name": "Enter your full name",
    "name_vibration_analysis": "Your name carries specific numerical vibrations that influence your destiny",
    "email_address": "Email Address",
    "enter_email_address": "Enter your email address",
    "phone_number": "Phone Number",
    "enter_phone_number": "Enter your phone number",
    "gender": "Gender",
    "male": "Male",
    "female": "Female",
    "other": "Other",
    "date_of_birth": "Date of Birth",
    "birth_date_life_path_number": "Your birth date reveals your Life Path Number and core life purpose",
    "preferred_language": "Preferred Language",
    "english": "English",
    "hindi": "Hindi",
    "telugu": "Telugu",
    "kannada": "Kannada",
    "language_note": "Your numerology analysis will be delivered in the selected language",

    // Core Numerology Features
    "life_path_number_analysis": "Life Path Number Analysis",
    "destiny_number_insights": "Destiny Number Insights",
    "personality_number_traits": "Personality Number Traits",
    "lucky_numbers_and_colors": "Lucky Numbers & Colors",
    "career_compatibility_numbers": "Career Compatibility Numbers",
    "pdf_download": "Comprehensive PDF Report",

    "what_you_get": "What Your Numerology Analysis Includes",
    "complete_numerology_chart": "Complete Numerological Chart",
    "core_numbers_analysis": "Core Numbers Breakdown",
    "personal_year_predictions": "Personal Year Forecast",
    "compatibility_insights": "Numerical Compatibility Guide",

    // Actions & Buttons
    "pay_and_generate_analysis": "Get My Numerology Analysis",
    "processing_payment": "Processing Payment",
    "processing_request": "Generating Analysis",

    // Payment & Success Messages
    "thank_you": "Thank You",
    "payment_successful": "Payment Successful!",
    "numerology_analysis_processing": "Your numerology analysis is being calculated by our expert numerologists. You'll receive detailed insights into your numerical blueprint.",
    "order_id": "Order ID",
    "payment_id": "Payment ID",
    "amount_paid": "Amount Paid",

    // Delivery Information
    "delivery_information": "Delivery Information",
    "delivery_time": "Analysis Delivery",
    "within_12_hours_delivery_note": "Your detailed numerology report will be ready within 12 hours",
    "whatsapp_notification": "WhatsApp Updates",
    "whatsapp_delivery_note": "Receive instant notifications on WhatsApp",
    "email_delivery": "Email Delivery",
    "email_delivery_note": "Complete analysis delivered to",

    // What You'll Receive
    "what_youll_receive": "Your Numerology Analysis Package",
    "detailed_numerology_report": "Comprehensive Numerology Report (PDF)",
    "life_path_destiny_analysis": "Life Path & Destiny Number Analysis",
    "personal_numbers_meanings": "Personal Numbers & Their Meanings",
    "lucky_elements_guidance": "Lucky Elements & Guidance",
    "annual_forecast_insights": "Annual Numerological Forecast",

    // Visual Content
    "sample_numerology_analysis": "Sample Numerology Analysis",
    "life_path_number": "Life Path Number",
    "sample_life_path_description": "The Seeker - Analytical, spiritual, and introspective nature",
    "sample_numerology_description": "Preview of your personalized numerical analysis with detailed insights",
    "core_numbers": "Core Numbers",

    // Core Number Types
    "life_path": "Life Path",
    "destiny": "Destiny",
    "personality": "Personality",
    "soul_urge": "Soul Urge",
    "birthday": "Birthday",
    "maturity": "Maturity",

    // Status & Processing
    "your_numerology_analysis_status": "Your Numerology Analysis Status",
    "processing_your_analysis": "Calculating Your Numbers",
    "analysis_processing_message": "Our numerology experts are analyzing your numerical patterns and preparing your personalized insights.",
    "request_id": "Analysis ID",
    "status": "Status",
    "processing": "In Progress",
    "pending": "Queued",
    "email_notification_sent": "Confirmation email sent",
    "whatsapp_update_coming": "WhatsApp updates enabled",
    "delivery_within_12_hours": "Report ready within 12 hours",

    // Support & Contact
    "contact_support": "Contact Numerology Support",
    "need_help": "Need guidance?",
    "contact_us_at": "Reach us at",

    // Error Messages
    "please_fill_all_required_fields": "Please complete all required details",
    "payment_failed": "Payment unsuccessful. Please try again.",
    "processing_failed": "Analysis processing failed. Contact our support team.",

    // Core Numerology Numbers
    "life_path_number": "Life Path Number",
    "destiny_number": "Destiny Number",
    "personality_number": "Personality Number",
    "soul_urge_number": "Soul Urge Number",
    "birthday_number": "Birthday Number",
    "maturity_number": "Maturity Number",
    "expression_number": "Expression Number",
    "heart_desire_number": "Heart's Desire Number",

    // Number Meanings (1-9)
    "number_1_meaning": "Leadership, Independence, Pioneer",
    "number_2_meaning": "Cooperation, Partnership, Diplomacy",
    "number_3_meaning": "Creativity, Expression, Communication",
    "number_4_meaning": "Stability, Hard Work, Foundation",
    "number_5_meaning": "Freedom, Adventure, Change",
    "number_6_meaning": "Nurturing, Responsibility, Healing",
    "number_7_meaning": "Spirituality, Analysis, Wisdom",
    "number_8_meaning": "Material Success, Authority, Achievement",
    "number_9_meaning": "Humanitarian, Completion, Service",

    // Master Numbers
    "master_number_11": "Master Number 11 - Intuition & Inspiration",
    "master_number_22": "Master Number 22 - Master Builder",
    "master_number_33": "Master Number 33 - Master Teacher",

    // Personality & Character Analysis
    "core_personality_traits": "Core Personality Traits",
    "strengths_and_talents": "Natural Strengths & Talents",
    "challenges_to_overcome": "Challenges to Overcome",
    "life_lessons": "Key Life Lessons",
    "inner_motivation": "Inner Motivations",
    "outer_expression": "How Others See You",

    // Life Path Analysis
    "life_purpose": "Life Purpose & Mission",
    "career_guidance": "Career Path Guidance",
    "relationship_patterns": "Relationship Patterns",
    "financial_tendencies": "Money & Finance Tendencies",
    "health_insights": "Health & Wellness Insights",
    "spiritual_journey": "Spiritual Development Path",

    // Compatibility Analysis
    "love_compatibility": "Your Love Life",
    "friendship_compatibility": "Friendship Compatibility",
    "business_compatibility": "Business Partnership Compatibility",
    "family_dynamics": "Family Relationship Dynamics",
    "compatible_numbers": "Most Compatible Numbers",
    "challenging_numbers": "Potentially Challenging Numbers",

    // Lucky Elements
    "lucky_numbers": "Personal Lucky Numbers",
    "lucky_colors": "Auspicious Colors",
    "lucky_days": "Favorable Days",
    "lucky_gemstones": "Beneficial Gemstones",
    "lucky_directions": "Favorable Directions",
    "lucky_metals": "Auspicious Metals",

    // Personal Year Analysis
    "current_personal_year": "Current Personal Year",
    "personal_year_theme": "Year Theme & Focus",
    "monthly_guidance": "Month-by-Month Guidance",
    "opportunities_this_year": "Key Opportunities",
    "challenges_this_year": "Potential Challenges",
    "recommendations_this_year": "Year-Specific Recommendations",

    // Name Analysis
    "name_numerology": "Name Numerology Analysis",
    "first_name_vibration": "First Name Vibration",
    "last_name_influence": "Surname Influence",
    "full_name_power": "Complete Name Power",
    "nickname_effects": "Nickname Effects",
    "name_change_suggestions": "Name Optimization Suggestions",

    // Birth Date Analysis
    "birth_date_significance": "Birth Date Significance",
    "day_vibration": "Day Number Influence",
    "month_influence": "Birth Month Impact",
    "year_energy": "Birth Year Energy",
    "complete_birth_pattern": "Complete Birth Pattern Analysis",

    // Karmic Numbers
    "karmic_debt_numbers": "Karmic Debt Numbers",
    "karmic_lessons": "Karmic Life Lessons",
    "soul_contracts": "Soul Contracts & Agreements",
    "past_life_influences": "Past Life Numerical Influences",

    // Cycles & Periods
    "life_cycles": "Major Life Cycles",
    "pinnacle_numbers": "Pinnacle Period Numbers",
    "challenge_numbers": "Challenge Period Numbers",
    "personal_months": "Personal Monthly Cycles",

    // Advanced Analysis
    "master_numbers_significance": "Master Numbers in Your Chart",
    "missing_numbers": "Missing Numbers Analysis",
    "repeated_numbers": "Repeated Numbers Significance",
    "intensity_table": "Numerical Intensity Analysis",

    // Practical Applications
    "best_dates_for_decisions": "Best Dates for Important Decisions",
    "timing_for_ventures": "Optimal Timing for New Ventures",
    "home_address_analysis": "Home Address Numerology",
    "phone_number_analysis": "Phone Number Vibrations",
    "choosing_baby_names": "Numerological Baby Name Guidance",

    // Remedies & Recommendations
    "numerical_remedies": "Numerological Remedies",
    "color_therapy": "Color Therapy Recommendations",
    "gemstone_suggestions": "Gemstone Recommendations",
    "mantras_for_numbers": "Number-Specific Mantras",
    "meditation_techniques": "Numerical Meditation Practices",

    // Business & Career
    "business_name_analysis": "Business Name Numerology",
    "career_number_alignment": "Career-Number Alignment",
    "partnership_numbers": "Business Partnership Numbers",
    "investment_timing": "Investment Timing Guidance",
    "product_launch_dates": "Product Launch Date Selection"
};
